export default __webpack_public_path__ + "static/media/Group 5.3aa272d3.png";